module.exports = __webpack_public_path__ + "static/media/55.4a7c7b81.png";